import DefaultLayout from '##/Default';
import UnitSummary from './UnitSummary';
import ViewCounts from './ViewCounts';
import ViewEvictions from './viewEvictions';
import ViewFlaggedAccounts from './ViewFlaggedAccounts';
import Financial from './Financial';
import EmployeeDiscounts from './EmployeeDiscounts';
import ViewAvailable from './viewAvailable';
import ViewAllPricing from './viewAllPricing';
import LeaseTradeOut from './leaseTradeOut';
import Whips from './whips';

const routes = [

    {
        path: '/portfolio/unit-summary',
        exact: true,
        layout: DefaultLayout,
        component: UnitSummary,
        auth: true,
        title: 'Unit Summary'
    },
    {
        path: '/portfolio/flagged',
        exact: true,
        layout: DefaultLayout,
        component: ViewFlaggedAccounts,
        auth: true,
        title: 'Flagged Accounts'
    },
    {
        path: '/portfolio/counts',
        exact: true,
        layout: DefaultLayout,
        component: ViewCounts,
        auth: true,
        title: 'Counts Report'
    },
    {
        path: '/portfolio/evictions',
        exact: true,
        layout: DefaultLayout,
        component: ViewEvictions,
        auth: true,
        title: 'Counts Report'
    },
    {
        path: '/portfolio/available',
        exact: true,
        layout: DefaultLayout,
        component: ViewAvailable,
        auth: true,
        title: 'Available Report'
    },
    {
        path: '/portfolio/allPricing',
        exact: true,
        layout: DefaultLayout,
        component: ViewAllPricing,
        auth: true,
        title: 'All Pricing Report'
    },
    {
        path: '/portfolio/financial',
        exact: true,
        layout: DefaultLayout,
        component: Financial,
        auth: true,
        title: 'Financial Report'
    },
    {
        path: '/portfolio/employee-discounts',
        exact: true,
        layout: DefaultLayout,
        component: EmployeeDiscounts,
        auth: true,
        title: 'Employee Discounts'
    },
    {
        path: '/portfolio/employee-discounts/:id',
        exact: true,
        layout: DefaultLayout,
        component: EmployeeDiscounts,
        auth: true,
        title: 'Employee Discounts'
    },
    {
        path: '/portfolio/lease-trade-out',
        exact: true,
        layout: DefaultLayout,
        component: LeaseTradeOut,
        auth: true,
        title: 'Lease TradeOut'
    },
    {
        path: '/portfolio/whips',
        exact: true,
        layout: DefaultLayout,
        component: Whips,
        auth: true,
        title: 'Whips'
    }
];


export default routes;
